export default __webpack_public_path__ + "static/calendar-493edb664c86e6a3efd87a64a4caf591.png";